import { gql } from '@apollo/client';

export const QUERY_PRICING_SCHEMES = gql`
  query QueryPricingSchemes(
    $businessScenario: Long
    $clientId: Long
    $pricingSchemeId: Long
    $creatorName: String
    $createdAtStart: String
    $createdAtEnd: String
    $page: Int!
    $size: Int!
  ) {
    queryPricingSchemes(
      businessScenario: $businessScenario
      clientId: $clientId
      pricingSchemeId: $pricingSchemeId
      creatorName: $creatorName
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      page: $page
      size: $size
    ) {
      items {
        id
        pricingSchemeName
        clientId
        clientName
        pricingSchemeDesc
        bindCount
        businessScenario
        creator
        operator
        createdAt
        updatedAt
        __typename
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
      __typename
    }
  }
`;

export interface PricingSchemeItem {
  id: number;
  pricingSchemeName: string;
  clientId: number;
  clientName?: string;
  pricingSchemeDesc?: string;
  bindCount?: number;
  businessScenario: number;
  creator?: string;
  operator?: string;
  createdAt?: string;
  updatedAt?: string;
  __typename: string;
}

export interface PricingSchemePageResult {
  items: PricingSchemeItem[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
  __typename: string;
}

export interface PricingSchemeQueryResponse {
  queryPricingSchemes: PricingSchemePageResult;
}

